import { Injectable, Inject } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';

import { DEFAULT_PAGE_SIZE } from '../../constants/commonConstants';
import { InvoiceEvents } from './events';
import { ENV_CONFIG } from 'src/app/core/injection.token';

type DynamicResponse<T> = app.models.DynamicResponse<T>;
type DynamicPaged<T> = app.models.DynamicResponse<app.models.PagedResult<T>>;

@Injectable()
export class InvoiceAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'invoice';

  public getPagedInvoices(pageIndex: number, pageFilter: app.models.GetPagedInvoicesPageFilterModel) {
    let data = { ...pageFilter, page: pageIndex, size: DEFAULT_PAGE_SIZE };

    const request = 'getPagedInvoices';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.post<DynamicPaged<app.models.InvoiceListModel>>(url, data);
  }

  public getInvoicedSummary(pageFilter: any) {
    const request = 'getInvoicedSummary';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.post<DynamicResponse<app.models.GetInvoicedSummaryModel>>(url, pageFilter);
  }

  public getFilterCategories() {
    const request = 'getFilterCategories';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.GetFilterCategoriesModel[]>(url);
  }

  public getInvoice(invoiceId: string) {
    const request = 'getInvoice';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request, {
      invoiceId: invoiceId,
    });

    return this._apiService.get<DynamicResponse<app.models.GetInvoiceModel>>(url);
  }

  public getDashboardInvoicesData() {
    const request = 'getDashboardInvoices';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.dashboard.InvoicesDataModel>(url);
  }

  public getInvoiceFile(invoiceId: string) {
    const body = {
      invoiceId: invoiceId,
    };
    const request = 'getInvoiceFile';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request);
    return this._apiService.postAsync<any>(
      url,
      body,
      [InvoiceEvents.InvoiceFileSaved],
      [InvoiceEvents.InvoiceFileSaved],
      [InvoiceEvents.GenerateInvoiceFileFailed, InvoiceEvents.InvoiceFileSaveFailed]
    );
  }
}
